import React from 'react'

import subscribe from '../../../assets/subscribe2.png'

const HomeSubscribe = () => {
	return (
		<section
			className='homepage_subscribe'
			style={{ background: `url(${subscribe})` }}
		>
			<div className='container'>
				<div className='d-flex justify-content-center homepage_subscribe_box'>
					<div className=''>
						<h3>Get Our Complete Crowdfunding Guide</h3>
						<form action=''>
							<div className='input-group mb-3'>
								<input
									type='email'
									className='form-control'
									placeholder='Enter Email Address'
									aria-label="Recipient's email"
									aria-describedby='button-addon2'
								/>
								<input
									type='number'
									className='form-control d-none'
									placeholder=''
								/>
								<button className='btn' type='button' id=''>
									Subscribe
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</section>
	)
}

export default HomeSubscribe
